import { Routes } from '@angular/router';
import { GenericPageComponent } from './generic-page.component';
import { policyPageResolver } from './generic-page.resolver';

export default [
    {
        path     : '',
        component: GenericPageComponent,
        resolve  : {
            policyData: policyPageResolver,
        },
    },
] as Routes;
